import api from '@/api/api';
import store from '../../store/store';

export const atividadeService = {
  getAtividade,
  atualizaAtividade,
  deletaAtividade,
  finalizaAtividade,
  voltaStatusAtividade,
  getAtividadeOcorrencias,
  addAtividadeOcorrencia,
  updateAtividadeOcorrencia,
  deleteAtividadeOcorrencia,
  getAtividadeChecklists,
  addAtividadeChecklist,
  updateAtividadeChecklist,
  deleteAtividadeChecklist,
  getAtividadeColaboradores,
  deleteAtividadeColaborador,
  getAtividadeClientes,
  deleteAtividadeCliente,
  getAtividadeTags,
  deleteAtividadeTag,
  getAtividadeProjetos,
  addAtividadeColaborador,
  addAtividadeCliente,
  addAtividadeTag,
  iniciarAtividade,
  pausarAtividade,
  getTodayAtividades,
  getAtividadesPendentesByType,
  getAtividadesFuturasByType,
  getAtividadeAtividades,
  getAtividadesVincular
};

// Atividades

function getAtividade(id) {
  return api.get(`atividades/${id}`);
}

function getTodayAtividades() {
  const { IdColaborador } = store.getters.user;
  return api.get(`atividades?Acao=AtividadesHoje&idResponsavel=${IdColaborador}`);
}

function getAtividadesPendentesByType(type) {
  const { IdColaborador } = store.getters.user;
  return api.get(`atividades?Acao=AtividadesPendentesPorTipo&idResponsavel=${IdColaborador}&idTipoAtividade=${type}`);
}

function getAtividadesFuturasByType(type) {
  const { IdColaborador } = store.getters.user;
  return api.get(`atividades?Acao=AtividadesFuturasPorTipo&idResponsavel=${IdColaborador}&idTipoAtividade=${type}`);
}

function iniciarAtividade(id) {
  return api.put(`atividades/${id}`, {
    IdAtividade: id,
    Acao: 'IniciaAtividade'
  });
}

function pausarAtividade(IdAtividade) {
  return api.put(`atividades/${IdAtividade}`, {
    IdAtividade,
    Acao: 'PausaAtividade'
  });
}

function atualizaAtividade(atividade) {
  return api.put(`atividades/${atividade.IdAtividade}`, atividade);
}

function deletaAtividade(id) {
  return api.delete(`atividades/${id}`);
}

function finalizaAtividade(atividade) {
  atividade.Acao = "FinalizaAtividade";
  return api.put(`atividades/${atividade.IdAtividade}`, atividade);
}

function voltaStatusAtividade(IdAtividade) {
  return api.put(`atividades/${IdAtividade}`, {
    IdAtividade,
    Acao: 'VoltaStatusAtividade'
  });
}

function getAtividadesVincular({ status, idTipoAtividade, idResponsavel, dataInicial, dataFinal, idAtividade }) {
  return api.get(`atividades?Acao=AtividadesVincular&idResponsavel=${idResponsavel}&status=${status}&idTipoAtividade=${idTipoAtividade}&dataInicio=${dataInicial}&dataFinal=${dataFinal}&idAtividade=${idAtividade}`);
}

// Ocorrencias

function getAtividadeOcorrencias(id) {
  return api.get(`atividadesocorrencias/1/${id}`);
}

function addAtividadeOcorrencia(ocorrencia) {
  return api.post(`atividadesocorrencias`, ocorrencia);
}

function updateAtividadeOcorrencia(ocorrencia) {
  return api.put(`atividadesocorrencias`, ocorrencia);
}

function deleteAtividadeOcorrencia(ocorrencia) {
  return api.delete(`atividadesocorrencias/1/${ocorrencia.IdAtividade}/${ocorrencia.IdOcorrencia}`);
}

// Checklists

function getAtividadeChecklists(id) {
  return api.get(`atividadeschecklists/1/${id}`);
}

function addAtividadeChecklist(checklist) {
  return api.post(`atividadeschecklists`, checklist);
}

function updateAtividadeChecklist(checklist) {
  return api.put(`atividadeschecklists`, checklist);
}

function deleteAtividadeChecklist(checklist) {
  return api.delete(`atividadeschecklists/1/${checklist.IdAtividade}/${checklist.IdChecklist}`);
}

// Colaboradores

function getAtividadeColaboradores(id) {
  return api.get(`atividadescolaboradores/1/${id}`);
}

function addAtividadeColaborador(colaborador) {
  return api.post(`atividadescolaboradores`, colaborador);
}

function deleteAtividadeColaborador(colaborador) {
  return api.delete(`atividadescolaboradores/1/${colaborador.IdAtividade}/${colaborador.IdColaborador}`);
}

// Clientes

function getAtividadeClientes(id) {
  return api.get(`atividadesclientes/1/${id}`);
}

function addAtividadeCliente(cliente) {
  return api.post(`atividadesclientes`, cliente);
}

function deleteAtividadeCliente(cliente) {
  return api.delete(`atividadesclientes/1/${cliente.IdAtividade}/${cliente.IdCliente}`);
}

// Tags

function getAtividadeTags(id) {
  return api.get(`atividadestags/1/${id}`);
}

function addAtividadeTag(tag) {
  return api.post(`atividadestags`, tag);
}

function deleteAtividadeTag(tag) {
  return api.delete(`atividadestags/1/${tag.IdAtividade}/${tag.IdTag}`)
}

// Projetos vinculados

function getAtividadeProjetos(id) {
  return api.get(`atividadesvinculosprojetos/1/${id}`);
}

// Atividades vinculadas

function getAtividadeAtividades(id) {
  return api.get(`atividadesvinculosatividades/1/${id}`);
}